module.exports = __webpack_public_path__ + "static/media/arrow-down.6b170085.svg";